import { useContext, useEffect, useState } from "react"
import { Checkbox, Dropdown, Form, Input } from "semantic-ui-react"
import { FiCheck, FiClock, FiMail, FiUsers, FiX } from "react-icons/fi"
import { Button } from "../../../designSystems/components/Button"
import { Container } from "./style"
import { RegisterPageContext } from "../../../context/RegisterPageContext"
import { NetworksPartnersProps } from "../../../models/NetworksPartnersProps"
import { Modal } from "../../../designSystems/components/Modal"
import closeInputIcon from "../../../assets/img/icons/close-input.svg"
import { GlobalContext } from "../../../context/GlobalContext"
import { useNavigate } from "react-router"
import { Controller, SubmitHandler, useForm } from "react-hook-form"
import { getNetworksPartners, createNetworksPartners, updateNetworksPartners, sendInvitation, fetchInvitations, fetchInitiatives, respondPartnership } from "../../../api/networks-partners"
import axios from "axios"
import { InitiativePartnerOtherProps } from "../../../models/InitiativePartnerOtherProps"
import { URL_PUBLIC } from "../../../services/api"
import emptyImg from "../../../assets/img/empty-img.svg"

const defaultOptions = [
    { key: 'none', text: 'Selecione ...', value: undefined },
    { key: 1, text: 'Sim', value: 1 },
    { key: 2, text: 'Não', value: 2 },
]

type PartnershipItem = {
    id?: number
    user_id?: number
    initiativeName?: string
    name?: string
    email?: string
    logo?: string
    request_id?: number
    status?: 'pending' | 'accepted' | 'rejected'
    direction?: 'incoming' | 'outgoing'
    type?: string
}

export const NetworksPartnersContent = (): JSX.Element => {
    const [isSubmitAction, setIsSubmitAction] = useState(false)
    const [initiatives, setInitiatives] = useState<number[]>([])
    const [newInitiativeNameModal, setNewInitiativeNameModal] = useState<any>(undefined);
    const [newInitiativeEmailModal, setNewInitiativeEmailModal] = useState<any>(undefined);
    const [updateAction, setUpdateAction] = useState(false)
    const [initiativesOptions, setInitiativesOptions] = useState<any[]>([])
    const [initiativesPartnersOthers, setInitiativesPartnersOthers] = useState<InitiativePartnerOtherProps[]>([])
    const [incomingPending, setIncomingPending] = useState<PartnershipItem[]>([])
    const [outgoingPending, setOutgoingPending] = useState<PartnershipItem[]>([])
    const [acceptedPartners, setAcceptedPartners] = useState<PartnershipItem[]>([])
    const [invitedBy, setInvitedBy] = useState<PartnershipItem | null>(null)

    const { setCurrentPage, handleScroll } = useContext(RegisterPageContext)
    const { setIsLoading, setDataToast, changeLastStep, getErrorMessage, vertifyAuthenticatedRedirect, userId, userData, pathnameIsAdmin, showNextRegisterButton } = useContext(GlobalContext)

    const { handleSubmit, control, setValue } = useForm<NetworksPartnersProps>(
        {
            defaultValues: {
                id: undefined,
                partnerForumNetwork: undefined,
                initiatives: [],
                initiativesOthers: [],
            }
        }
    );

    const navigate = useNavigate()

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = (): void => {
        setIsLoading(true)
        const params = pathnameIsAdmin() ? { user_id: userId } : null

        axios.all([
            getNetworksPartners(params),
            fetchInitiatives(),
            fetchInvitations(params),
        ]).then((response: any) => {
            setIsLoading(false)

            if (response[1].data.data.initiative.length) {
                const options = response[1].data.data.initiative.map((item: any) => ({ 'key': item.id, 'text': item.initiativeName, 'value': item.id }))
                setInitiativesOptions(options)
            }

            if (response[1].data.data.others.length) {
                setInitiativesPartnersOthers(response[1].data.data.others.filter((item: any) => item !== null))
            }

            if (response[0].data.data.length) {
                setUpdateAction(true)
                const responseData: NetworksPartnersProps = response[0].data.data[0]
                fillForm(responseData, response[1].data.data.initiative)
            }

            const received = response[2]?.data?.data || {}
            setIncomingPending(Array.isArray(received.incomingPending) ? received.incomingPending : [])
            setOutgoingPending(Array.isArray(received.outgoingPending) ? received.outgoingPending : [])
            setAcceptedPartners(Array.isArray(received.accepted) ? received.accepted : [])
            setInvitedBy(received.invitedBy || null)
        }).catch(err => {
            setIsLoading(false)
            const textError = err.response.data.message === 'Unauthorized' ? 'Erro ao buscar informações' : getErrorMessage(err.response.data.message)
            setDataToast({ show: true, text: textError })
            if (vertifyAuthenticatedRedirect(err.response.data.message)) {
                goToPage('/')
            }
        })
    }

    const fillForm = (data: NetworksPartnersProps, options: any[]): void => {
        setValue('id', data.id)
        let initiativesOptionsValues: number[] = []

        if (options.length) {
            initiativesOptionsValues = options.map((item: any) => ({ 'key': item.id, 'text': item.initiativeName, 'value': item.id })).map(item => item.value)
        }

        const initiatives = (data.initiatives as number[]).filter(d => initiativesOptionsValues.includes(d))

        setValue('partnerForumNetwork', data.partnerForumNetwork)
        setValue('initiatives', initiatives)
        setInitiatives(initiatives)
    }

    const onChangeInitiatives = (checked: boolean | undefined, key: number): void => {
        let initiativesList: number[] = [...initiatives];

        if (checked) {
            initiativesList.push(key)
        } else {
            initiativesList = initiativesList.filter(k => k !== key)
        }

        setInitiatives(initiativesList)
        setValue('initiatives', initiativesList)
    }

    const isInitiativeChecked = (key: number, dataList: number[]): boolean => {
        return dataList.length ? dataList?.includes(key) : false
    }

    const goToPage = (path: string): void => {
        navigate(path)
    }

    const clearInvitePartner = (): void => {
        setNewInitiativeNameModal('')
        setNewInitiativeEmailModal('')
    }

    const invitePartner = (): void => {
        let btnCloseElem: HTMLElement = document.querySelector('.modal.new-account-modal .btn-first') as HTMLElement

        const dataForm = {
            name: newInitiativeNameModal,
            email: newInitiativeEmailModal,
        }

        setIsLoading(true)

        sendInvitation(dataForm).then(() => {
            setIsLoading(false)
            setDataToast({ show: true, text: 'Convite enviado com sucesso!!!' })
            fetchData()
        }).catch((err: any) => {
            setIsLoading(false)
            const textError = err.response.data.message === 'Unauthorized' ? 'Erro ao enviar convite!' : getErrorMessage(err.response.data.message)
            setDataToast({ show: true, text: textError })
            if (vertifyAuthenticatedRedirect(err?.response?.data?.message)) {
                goToPage('/')
            }
        }).finally(() => {
            btnCloseElem.click()
        })
    }

    const isInitiativePartnerOthersChecked = (data: InitiativePartnerOtherProps, dataList: InitiativePartnerOtherProps[]): boolean => {
        return dataList.length > 0 && dataList.filter(item => item.id === data.id).length > 0
    }

    const onChangeInitiativePartnerOthers = (checked: boolean | undefined, info: InitiativePartnerOtherProps): void => {
        let initiativesPartnersOthersList: InitiativePartnerOtherProps[] = [...initiativesPartnersOthers];

        if (!checked) {
            initiativesPartnersOthersList = initiativesPartnersOthersList.filter(o => o.id !== info.id)
        }

        setInitiativesPartnersOthers(initiativesPartnersOthersList)
        setValue('initiativesOthers', initiativesPartnersOthersList)
    }

    const [confirmRespond, setConfirmRespond] = useState<{
        requestId: number
        status: 'accepted' | 'rejected'
        name: string
    } | null>(null)

    useEffect(() => {
        if (!confirmRespond) return

        const modalElement = document.getElementById('confirmPartnershipModal')
        const bootstrapApi = (window as any).bootstrap
        if (!modalElement || !bootstrapApi?.Modal) return

        bootstrapApi.Modal.getOrCreateInstance(modalElement).show()
    }, [confirmRespond])

    const askRespond = (partner: PartnershipItem, status: 'accepted' | 'rejected'): void => {
        if (!partner.request_id) return

        setConfirmRespond({
            requestId: partner.request_id,
            status,
            name: partner.initiativeName || partner.name || 'esta iniciativa',
        })
    }

    const closeConfirmRespond = (): void => {
        const modalElement = document.getElementById('confirmPartnershipModal')
        const bootstrapApi = (window as any).bootstrap
        if (modalElement && bootstrapApi?.Modal) {
            bootstrapApi.Modal.getOrCreateInstance(modalElement).hide()
        }
    }

    const handleRespond = (requestId: number | undefined, status: 'accepted' | 'rejected'): void => {
        if (!requestId) return

        setIsLoading(true)
        const params = pathnameIsAdmin() ? { user_id: userId } : null
        respondPartnership({ request_id: requestId, status }, params).then(() => {
            setIsLoading(false)
            setDataToast({
                show: true,
                text: status === 'accepted' ? 'Parceria aceita! Agora vocês são parceiros.' : 'Pedido de parceria recusado.',
            })
            fetchData()
        }).catch((err: any) => {
            setIsLoading(false)
            const textError = err.response?.data?.message === 'Unauthorized'
                ? 'Erro ao responder parceria'
                : getErrorMessage(err.response?.data?.message)
            setDataToast({ show: true, text: textError })
        })
    }

    const create = (dataForm: NetworksPartnersProps): void => {
        setIsLoading(true)
        createNetworksPartners(dataForm).then(() => {
            setIsLoading(false)
            setDataToast({ show: true, text: 'Pedidos de parceria enviados. Eles ficam pendentes até o aceite.' })
            setCurrentPage('solidarity-bank')
            changeLastStep(5)
        }).catch(err => {
            setIsLoading(false)
            handleScroll()
            const textError = err.response.data.message === 'Unauthorized' ? 'Erro ao salvar' : getErrorMessage(err.response.data.message)
            setDataToast({ show: true, text: textError })
            if (vertifyAuthenticatedRedirect(err.response.data.message)) {
                goToPage('/')
            }
        }).finally(() => setIsSubmitAction(false))
    }

    const update = (dataForm: NetworksPartnersProps): void => {
        setIsLoading(true)
        updateNetworksPartners(dataForm).then(() => {
            setIsLoading(false)
            setDataToast({ show: true, text: 'Pedidos atualizados. Novas parcerias ficam pendentes até o aceite.' })
            setCurrentPage('solidarity-bank')
        }).catch(err => {
            setIsLoading(false)
            handleScroll()
            const textError = err.response.data.message === 'Unauthorized' ? 'Erro ao salvar' : getErrorMessage(err.response.data.message)
            setDataToast({ show: true, text: textError })
            if (vertifyAuthenticatedRedirect(err.response.data.message)) {
                goToPage('/')
            }
        }).finally(() => setIsSubmitAction(false))
    }

    const onSubmit: SubmitHandler<NetworksPartnersProps> = data => {
        const dataForm: NetworksPartnersProps = { ...data, partnerForumNetwork: data.partnerForumNetwork || 0, initiativesOthers: [...initiativesPartnersOthers] }

        if (isSubmitAction) {
            updateAction ? update(dataForm) : create(dataForm)
        }
    }

    const renderPartnerCard = (
        partner: PartnershipItem,
        options?: { showRespond?: boolean; badge?: string; badgeClass?: string }
    ) => (
        <div className={`received-card ${partner.status || ''}`} key={`${partner.request_id || partner.id}-${partner.user_id}`}>
            <div className="received-main">
                <img src={partner.logo ? `${URL_PUBLIC}${partner.logo}` : emptyImg} alt="" />
                <div className="received-info">
                    {options?.badge && (
                        <span className={`badge ${options.badgeClass || ''}`}>
                            {options.badgeClass === 'pending' && <FiClock size={12} />}
                            {options.badgeClass === 'accepted' && <FiCheck size={12} />}
                            {options.badgeClass === 'invite' && <FiMail size={12} />}
                            {options.badge}
                        </span>
                    )}
                    <strong>{partner.initiativeName || partner.name}</strong>
                    {partner.email && <span className="meta">{partner.email}</span>}
                </div>
            </div>

            {options?.showRespond && (
                <div className="respond-actions">
                    <button type="button" className="btn-accept" onClick={() => askRespond(partner, 'accepted')}>
                        <FiCheck size={16} strokeWidth={2.5} />
                        Aceitar
                    </button>
                    <button type="button" className="btn-reject" onClick={() => askRespond(partner, 'rejected')}>
                        <FiX size={16} strokeWidth={2.5} />
                        Recusar
                    </button>
                </div>
            )}
        </div>
    )

    return (
        <Container countInitiatives={initiatives.length}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="networks-layout">
                    <div className="networks-main">
                        <div className="section-intro">
                            <h3>Suas parcerias</h3>
                            <p>
                                Ao selecionar uma iniciativa e salvar, o pedido fica <strong>pendente</strong> até ela aceitar.
                                Só depois disso vocês passam a ser parceiros de fato.
                            </p>
                        </div>

                        <div className="row">
                            <div className="col-md-6 field-col-align">
                                <Controller
                                    name="partnerForumNetwork"
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <Form.Select
                                            fluid
                                            size="huge"
                                            label='Sua iniciativa atua em parceria ou faz parte de algum fórum ou rede?'
                                            placeholder='Selecione ...'
                                            value={value}
                                            options={defaultOptions}
                                            onChange={function (e, { value }) {
                                                onChange(value)
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-6 field-col-align">
                                <label className="label-form-default">Solicitar parceria com:</label>
                                <div className="field dropdown-initiatives">
                                    <Dropdown
                                        placeholder='Selecione ...'
                                        fluid
                                        multiple
                                        search
                                        selection
                                        clearable
                                        options={initiativesOptions}
                                        value={initiatives}
                                        onChange={function (e, { value }) {
                                            setInitiatives(value as number[])
                                            setValue('initiatives', value as number[])
                                        }}
                                    >
                                        <Dropdown.Menu>
                                            {initiativesOptions.map(op => (
                                                <Dropdown.Item
                                                    key={op.key}
                                                    onClick={() => {
                                                        let resValues = []

                                                        if (initiatives.includes(op.key)) {
                                                            resValues = initiatives.filter((item: number) => item !== op.key)
                                                        } else {
                                                            resValues = [...initiatives, op.key]
                                                        }

                                                        setInitiatives(resValues)
                                                        setValue('initiatives', resValues as number[])
                                                    }}
                                                >
                                                    <Checkbox
                                                        label={op.text}
                                                        checked={initiatives.includes(op.key)}
                                                    />
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>

                        <div className="received-section">
                            <div className="section-head">
                                <div className="section-icon">
                                    <FiUsers size={20} />
                                </div>
                                <div>
                                    <h3>Pedidos e parcerias</h3>
                                    <p>Aceite pedidos recebidos, acompanhe os que você enviou e veja as parcerias confirmadas.</p>
                                </div>
                            </div>

                            <div className="partnership-group">
                                <h4>Pedidos recebidos {incomingPending.length > 0 && <span>{incomingPending.length}</span>}</h4>
                                {!incomingPending.length && (
                                    <div className="received-empty">Nenhum pedido pendente para você no momento.</div>
                                )}
                                {incomingPending.map(partner =>
                                    renderPartnerCard(partner, {
                                        showRespond: true,
                                        badge: 'Aguardando seu aceite',
                                        badgeClass: 'pending',
                                    })
                                )}
                            </div>

                            <div className="partnership-group">
                                <h4>Enviados por você {outgoingPending.length > 0 && <span>{outgoingPending.length}</span>}</h4>
                                {!outgoingPending.length && (
                                    <div className="received-empty">Você não tem pedidos aguardando resposta.</div>
                                )}
                                {outgoingPending.map(partner =>
                                    renderPartnerCard(partner, {
                                        badge: 'Pendente — aguardando aceite',
                                        badgeClass: 'pending',
                                    })
                                )}
                            </div>

                            <div className="partnership-group">
                                <h4>Parceiros aceitos {acceptedPartners.length > 0 && <span>{acceptedPartners.length}</span>}</h4>
                                {!acceptedPartners.length && (
                                    <div className="received-empty">Ainda não há parcerias confirmadas.</div>
                                )}
                                {acceptedPartners.map(partner =>
                                    renderPartnerCard(partner, {
                                        badge: 'Parceiros',
                                        badgeClass: 'accepted',
                                    })
                                )}
                            </div>

                            {invitedBy && (
                                <div className="partnership-group">
                                    <h4>Convite de cadastro</h4>
                                    {renderPartnerCard(invitedBy, {
                                        badge: 'Convidou você para o mapa',
                                        badgeClass: 'invite',
                                    })}
                                </div>
                            )}
                        </div>
                    </div>

                    {userData.permissaos_id === 3 &&
                        <div className="networks-side">
                            <div className="new-initiatives">
                                <div className="text">
                                    <strong>Selecionados / convites</strong>
                                    <span>Ao salvar, os novos selecionados geram pedido pendente até o aceite.</span>
                                </div>

                                {initiatives.length > 0 &&
                                    <div className="initiatives-list">
                                        {initiativesOptions.map((o) => {
                                            return isInitiativeChecked(o.key, initiatives) && (
                                                <div className="col-md-12" key={o.key}>
                                                    <Checkbox
                                                        label={o.text}
                                                        checked={isInitiativeChecked(o.key, initiatives)}
                                                        onChange={(e, { checked }) => {
                                                            onChangeInitiatives(checked, o.key)
                                                        }}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>
                                }

                                {initiatives.length === 0 && initiativesPartnersOthers.length === 0 && (
                                    <div className="side-empty">Nenhuma iniciativa selecionada ainda.</div>
                                )}

                                {initiativesPartnersOthers.length > 0 &&
                                    <div className="initiatives-others">
                                        <hr />
                                        <div className="others-label">Convites enviados por e-mail</div>
                                        {initiativesPartnersOthers.map((info, index) => (
                                            <div className="col-md-12" key={index}>
                                                <Checkbox
                                                    label={info?.name}
                                                    checked={isInitiativePartnerOthersChecked(info, initiativesPartnersOthers)}
                                                    onChange={(e, { checked }) => {
                                                        onChangeInitiativePartnerOthers(checked, info)
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                }
                                <div>
                                    <Button
                                        text="Convidar parceiro"
                                        className="radius-100 btn-outline-gray"
                                        isBtnModal
                                        type="button"
                                        targetModalName="newInitiativeModalTarget"
                                        onClick={() => clearInvitePartner()}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="footer">
                    <hr />
                    <div className="btn-actions f-right">
                        <Button
                            text="Anterior"
                            className="radius-100 btn-outline-gray mr-32"
                            onClick={() => setCurrentPage([1, 4].includes(userData.tipo_organizacao_id as number) ? 'financial' : 'about-initiative')}
                        />
                        {showNextRegisterButton(updateAction) &&
                            <Button
                                type="submit"
                                text="Próxima"
                                className="radius-100"
                                onClick={() => setIsSubmitAction(true)}
                            />
                        }
                    </div>
                </div>
            </Form>

            <Modal
                title={confirmRespond?.status === 'rejected' ? 'Recusar parceria?' : 'Aceitar parceria?'}
                type={confirmRespond?.status === 'rejected' ? 'delete' : 'create'}
                targetModalName="confirmPartnershipModal"
                btnFirstText="Cancelar"
                btnSecondText={confirmRespond?.status === 'rejected' ? 'Recusar' : 'Aceitar'}
                confirmAction={() => {
                    if (!confirmRespond) return
                    const { requestId, status } = confirmRespond
                    closeConfirmRespond()
                    handleRespond(requestId, status)
                }}
            >
                <div className="modal-description">
                    {confirmRespond?.status === 'rejected'
                        ? `Recusar o pedido de ${confirmRespond.name}? A parceria não será criada.`
                        : `Aceitar o pedido de ${confirmRespond?.name || 'esta iniciativa'}? Vocês passam a ser parceiros.`}
                </div>
            </Modal>

            <Modal
                title="Convidar parceiro"
                type="create"
                className="new-account-modal"
                targetModalName="newInitiativeModalTarget"
                btnSecondText="Aplicar"
                confirmAction={() => invitePartner()}
            >
                <div className="modal-description">
                    Complete os campos abaixo para convidar seu parceiro para fazer parte do Mapa PerifaSul:
                </div>

                <div className="fields">
                    <div className="field">
                        <Input
                            icon
                            size="huge"
                            placeholder='Escreva o nome completo'
                            value={newInitiativeNameModal}
                            onChange={function (e, { value }) {
                                setNewInitiativeNameModal(value)
                            }}
                        >
                            <label className="label-inside">Nome da iniciativa</label>
                            <input />
                            <div
                                className="img-icon flex-cc"
                                onClick={() => setNewInitiativeNameModal('')}
                            >
                                <img src={closeInputIcon} alt="close-input" />
                            </div>
                        </Input>
                    </div>

                    <div className="field">
                        <Input
                            icon
                            size="huge"
                            placeholder='Escreva o e-mail institucional'
                            value={newInitiativeEmailModal}
                            onChange={function (e, { value }) {
                                setNewInitiativeEmailModal(value)
                            }}
                        >
                            <label className="label-inside">E-mail</label>
                            <input />
                            <div
                                className="img-icon flex-cc"
                                onClick={() => setNewInitiativeEmailModal('')}
                            >
                                <img src={closeInputIcon} alt="close-input" />
                            </div>
                        </Input>
                    </div>
                </div>
            </Modal>
        </Container>
    )
}
